import { useEffect, useRef } from 'react';
import { FaGoogle } from 'react-icons/fa';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

let scriptPromise = null;
function loadGoogleScript() {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    if (window.google?.accounts?.id) return resolve();
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error('Failed to load Google script'));
    document.head.appendChild(script);
  });
  return scriptPromise;
}

export default function GoogleSignInButton({ onCredential, onError, text = 'continue_with' }) {
  const divRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    loadGoogleScript()
      .then(() => {
        if (cancelled || !divRef.current || !CLIENT_ID) return;
        window.google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: (response) => onCredential(response.credential),
        });
        window.google.accounts.id.renderButton(divRef.current, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text,
          shape: 'pill',
          width: 320,
        });
      })
      .catch(() => onError?.('Could not load Google sign-in. Please try again.'));

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!CLIENT_ID) return null;

 return (
  <div className="relative w-[320px] h-[40px] mx-auto">
    <div className="absolute inset-0 flex items-center justify-center gap-3 rounded-full bg-gradient-to-r from-[#9333EA] to-[#EC4899] text-sm font-medium text-white pointer-events-none">
      <FaGoogle size={16} />
      Continue with Google
    </div>
    <div
      ref={divRef}
      className="absolute inset-0 flex justify-center overflow-hidden opacity-[0.01]"
    />
  </div>
);
}